function onClickRedirect() {
    const container = document.querySelector(".microfiches-search-container");

    const redirectButtons = container.querySelectorAll("button");

    redirectButtons.forEach(button => {
   
        button.addEventListener("click", (e) => {
            const aTag = button.querySelector("a");
            window.location.href = aTag.href;
        })
    })
    
}
onClickRedirect()